/**
 * Invoices/Pay Controller
 *
 * Allows the user to pay their invoices
 */

// the constructor for this object
function InvoicesPayController() { }

// the object
InvoicesPayController.prototype = {
    constructor: InvoicesPayController,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
            
        PortalHelper.debugMessage('Invoices Pay Initialized');
    },
    
    // run the controller
    run: function()
    {
        // get the orders using the new account id
        PortalMain.InvoicesPayController._getBalanceHistory();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Invoices Pay Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        
    },
    
    // get the balance history from the api
    _getBalanceHistory: function()
    {
        
        // make the request
        var balanceHistoryRequest = new PortalRequest;
        balanceHistoryRequest.makeRequest(
            '/invoices/get-balance-history',
            {},
            function(data) {
                // fill the download invoice button
                PortalMain.InvoicesPayController._populateBalanceHistories(data);
            },
            function(data, code, message) {
            }
        );
    },
    
    // populate the balance history section
    _populateBalanceHistories: function(balanceHistories)
    {   
        
        // clear the old tickets
        $('.balance-history:not(.clone-source)').remove();
        
        // add the new tickets to the DOM
        for (var i in balanceHistories) {
            var balanceHistory = balanceHistories[i];
            var newEntry = $('.balance-history.clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // set the account data
            $('.account-number', newEntry).html(balanceHistory.account.account_number);
            $('.account-name', newEntry).html(balanceHistory.account.name);
            
            // set the 0 - 30
            var balance030 = PortalHelper.numberToDollars(balanceHistory['0-30']);
            $('.current', newEntry).html(balance030);
            
            // set the 30 - 60
            var balance3060 = PortalHelper.numberToDollars(balanceHistory['30-60']);
            $('.balance-30-60', newEntry).html(balance3060);
            
            // set the 60 - 90
            var balance6090 = PortalHelper.numberToDollars(balanceHistory['60-90']);
            $('.balance-60-90', newEntry).html(balance6090);
            
            // set the 90+
            var balance90 = PortalHelper.numberToDollars(balanceHistory['90+']);
            $('.balance-90', newEntry).html(balance90);
            
            // set the total outstanding
            var balance = PortalHelper.numberToDollars(balanceHistory.balance);
            $('.total-outstanding', newEntry).html(balance);
            
            // add to to the table
            $('#balance-histories').append(newEntry);
            
            
            // include the spacer box
            var newSpacer = $('.spacer.clone-source').clone();
            newSpacer.removeClass('clone-source');
            $('#balance-histories').append(newSpacer);
            
        }
    },
    
}